
// 首页---->左导航栏
<template>
  <div class="" style="position: relative;">
    <el-container style="height: auto">
      <!-- 侧边栏 -->

      <el-aside class='public-nav show-aside' v-if="isCollapse">
        <!--  unique-opened :unique-opened="true" 如果要收起菜单，就给el-menu加这个参数  #ffd04b  active-text-color="#1167E9"-->
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-nav"
          @select="handleselect"
          @open="handleOpen"
          @close="handleClose"
          ref="menus"
          :router="true"
          text-color="#fff"
          :unique-opened="true"
        >
          <li role="menuitem" aria-haspopup="true" class="el-submenu" v-if="hasPermission(616)">
            <div class="el-submenu__title" style="padding-left: 20px; color: rgb(255, 255, 255);">
            <div class="title navThemm" @click="handleToSupplyChain">
              <div class="icon-wrap">
                <svg-icon icon-class="supply-chain" style="font-size: 25px;"></svg-icon>
              </div>
              <span style="font-size: 16px;">产业协同</span>
            </div>
            </div>
          </li>

          <el-submenu index="5" v-if="hasPermissionGroup([...permissionGroup.productionManagement.personnelManagement,...permissionGroup.productionManagement.taskManagement])">
            <template slot="title">
              <div class="title navThemm">
                <div class="icon-wrap">
                  <svg-icon icon-class="shengchan" style="font-size: 25px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">生产管理</span>
              </div>
            </template>
            <el-menu-item-group>
              <el-menu-item
                class="secondary-menu"
                index="/productionManagement/personnelManagement"
                style="padding-left:80px"
                v-if="hasPermission(384)"
              >生产人员管理</el-menu-item>
              <el-menu-item
                class="secondary-menu"
                index="/productionManagement/taskManagement/index"
                style="padding-left:80px"
                v-if="hasPermission(385)"
              >生产任务管理</el-menu-item>
              <el-menu-item
                class="secondary-menu secondary-menu-else"
                index="/productionManagement/deviceCheck/index"
                style="padding-left:80px"
                v-if="hasPermission(443)"
              >生产检测标准</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="1"   v-if="hasPermissionGroup([...permissionGroup.assetManager.assetView,...permissionGroup.assetManager.assetInsert,...permissionGroup.assetManager.assetReport,...permissionGroup.assetManager.assetReportIt,...permissionGroup.assetManager.assetDeletion])">
            <template slot="title">
              <div class="title navThemm">
                <div class="icon-wrap">
                  <svg-icon icon-class="zichan" style="font-size: 30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">资产管理</span>
              </div>
            </template>
            <el-submenu index="1-1" v-if="hasPermissionGroup(permissionGroup.assetManager.assetView)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="chengxian" style="font-size: 17px;"></svg-icon>
                  </div>
                  <span style="font-size: 14px;">资产呈现</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/index"
                style="padding-left: 80px"
                v-if="hasPermission(182)"
                ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">资产地图</span></el-menu-item
              >
              <el-menu-item
                class="firstmenus"
                index="/battery/index"
                style="padding-left: 80px"
                v-if="hasPermission(2)"
                ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">电池列表</span></el-menu-item
              >
              <el-menu-item
                class="firstmenus"
                index="/assets/chargeCabinet/index"
                style="padding-left: 80px"
                v-if="hasPermission(115)"
                ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">换电柜列表</span></el-menu-item
              >
              <el-menu-item
                class="firstmenus"
                index="/assets/vehicleList/index"
                style="padding-left: 80px"
                v-if="hasPermission(456)"
                ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">车辆列表</span></el-menu-item
              >
              <el-menu-item
                class="firstmenus"
                index="/assets/terminalManagement/index"
                style="padding-left: 80px"
                v-if="hasPermission(282)"
                ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">设备终端</span></el-menu-item
              >
                <el-menu-item
                class="firstmenus"
                index="/assets/sharingVehicleMap/index"
                style="padding-left: 80px"
                v-if="hasPermission(575)"
                ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">共享车辆地图</span></el-menu-item
              >
            </el-submenu>

            <el-submenu index="1-2"  v-if="hasPermissionGroup(permissionGroup.assetManager.assetInsert)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="zichanluru" style="font-size: 17px;"></svg-icon>
                  </div>
                  <span style="font-size: 14px;">资产录入</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/assets/inventory/batteryList/index"
                v-if="hasPermission(5)"
                style="padding-left:80px;"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">电池</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/assets/inventory/chargeBox/index"
                v-if="hasPermission(117)"
                style="padding-left:80px;"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">换电柜</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/assets/vehicleInOutManagement/index"
                v-if="hasPermission(459)"
                style="padding-left:80px;"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">车辆出入库管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/assets/batterycategory/index"
                style="padding-left:80px"
                v-if="hasPermission(3)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">电池品牌型号管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/assets/chargeCabinetList/index"
                style="padding-left:80px"
                v-if="hasPermission(116)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">换电柜厂家型号管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/assets/vehicleBrandModel/index"
                style="padding-left:80px"
                v-if="hasPermission(460)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">车辆品牌型号管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/assets/inventory/storeManagement/index"
                v-if="hasPermission(244)"
                style="padding-left:80px;"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">仓库管理</span></el-menu-item>
               <el-menu-item
                index="/assets/FrameNumber/index"
                style="padding-left:80px"
                class="firstmenus"
                v-if="hasPermission(293)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">车架号管理</span></el-menu-item>
            </el-submenu>

             <el-menu-item index="/assetsReportIt/index" v-if="hasPermissionGroup(permissionGroup.assetManager.assetReportIt)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="zichangbaoshi" style="font-size: 17px;"></svg-icon>
                </div>
                <span style="font-size: 14px;">资产报失</span>
              </div>
            </el-menu-item>

            <el-menu-item index="/assetsReport/report" v-if="hasPermissionGroup(permissionGroup.assetManager.assetReport)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="zichanbaobiao" style="font-size: 22px;"></svg-icon>
                </div>
                <span style="font-size: 14px;">资产报表</span>
              </div>
            </el-menu-item>

              <el-menu-item index="/assets/assetDeletionRecord" v-if="hasPermissionGroup(permissionGroup.assetManager.assetDeletion)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="shouhoubaobiao" style="font-size: 16px;"></svg-icon>
                </div>
                <span style="font-size: 14px;">资产删除记录</span>
              </div>
            </el-menu-item>
          </el-submenu>
          <!-- <div class="bgcolor" v-if="hasPermissionGroup([...permissionGroup.assetManager.assetView,...permissionGroup.assetManager.assetInsert,...permissionGroup.assetManager.assetReport])" changeOperatorView></div> -->
          <el-submenu index="2"   v-if="hasPermissionGroup([...permissionGroup.operateManager.operateOverview,...permissionGroup.operateManager.operateOrder,...permissionGroup.operateManager.operateBusiness,
          ...permissionGroup.operateManager.operatePrice,...permissionGroup.operateManager.operateCustomer,...permissionGroup.operateManager.operateFinance,...permissionGroup.operateManager.operateReport,...permissionGroup.operateManager.changeOperatorView,
          ...permissionGroup.operateManager.marketingActivities,...permissionGroup.operateManager.remoteUpgrade])">
              <template slot="title">
              <div class="title navThemm">
                <div class="icon-wrap">
                  <svg-icon icon-class="yunyingguanli" style="font-size: 26px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">运营管理</span>
              </div>
            </template>
            <el-menu-item index="/operationOverview" v-if="hasPermissionGroup(permissionGroup.operateManager.operateOverview)" class="secondary-menu secondary-menu-else">
               <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="yunyinggaikuang" style="font-size: 24px" ></svg-icon>
                  </div>
                  <span style="font-size: 14px;">租赁运营概况</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/operation/changeOperatorView/index" v-if="hasPermissionGroup(permissionGroup.operateManager.changeOperatorView)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="yunyinggaikuang2" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 14px;">换电运营概况</span>
              </div>
            </el-menu-item>
            <el-submenu index="2-1" v-if="hasPermissionGroup(permissionGroup.operateManager.operateOrder)" class="secondary-menu">
              <template slot="title" >
                <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="dingdanguanli" style="font-size: 18px;"></svg-icon>
                 </div>
                 <span style="font-size: 14px;">订单管理</span>
                </div>
              </template>
              <el-menu-item
                index="/operation/order/exchange/index"
                class="firstmenus"
                style="padding-left:80px"
                v-if="hasPermission(75)"
              >
              <i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">换电订单</span></el-menu-item>
              <el-menu-item
                index="/operation/order/exchangeHistory/index"
                class="firstmenus"
                style="padding-left:80px"
                v-if="hasPermission(76)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">换电记录</span></el-menu-item>
              <el-menu-item
                index="/operation/order/lease/index"
                style="padding-left:80px"
                v-if="hasPermission(229)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">电池租赁订单</span></el-menu-item>
              <el-menu-item
                index="/operation/order/batteryReplacementRecord/index"
                style="padding-left:80px"
                v-if="hasPermission(419)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">电池更换记录</span></el-menu-item>
              <el-menu-item
                index="/operation/order/leaseExpired/index"
                style="padding-left:80px"
                v-if="hasPermission(230)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">租赁逾期订单</span></el-menu-item>
              <!-- display:none -->
              <el-menu-item
                index="/operation/order/salesOrder/index"
                style="padding-left:80px;"
                v-if="hasPermission(371)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">销售订单</span></el-menu-item>
              <el-menu-item
                index="/operation/order/carsLeaseOrder/index"
                style="padding-left:80px"
                v-if="hasPermission(480)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">车辆租赁订单</span></el-menu-item>
              <el-menu-item
                index="/operation/businessAccount/index"
                style="padding-left:80px"
                class="firstmenus"
                v-if="hasPermission(311)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">资产使用情况</span></el-menu-item>
            </el-submenu>
            <el-submenu index="2-2" v-if="hasPermissionGroup(permissionGroup.operateManager.operateBusiness)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="yewuguanli" style="font-size: 20px;"></svg-icon>
                 </div>
                 <span style="font-size: 14px;">业务管理</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/operation/operationList/index"
                style="padding-left:80px"
                v-if="hasPermission(11)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">运营商管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/proxy/index"
                style="padding-left:80px"
                v-if="hasPermission(596)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">代理商管理</span></el-menu-item>

              <el-menu-item
                class="firstmenus"
                index="/operation/operationSite"
                style="padding-left:80px"
                v-if="hasPermission(10)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">租赁点管理</span></el-menu-item>
               <el-menu-item
                class="firstmenus"
                index="/operation/LeasePointGroup/index"
                style="padding-left:80px"
                v-if="hasPermission(196)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">租赁点分组</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/brandFranchisee/index"
                style="padding-left:80px"
                v-if="hasPermission(262)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">品牌加盟商管理</span></el-menu-item>
              <el-menu-item
                index="/operation/allocation/index"
                style="padding-left:80px"
                class="firstmenus"
                v-if="hasPermission(14)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">调拨管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/pushHistory/index"
                style="padding-left:80px"
                v-if="hasPermission(242)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">消息推送记录</span></el-menu-item>
<!--              <el-menu-item-->
<!--                class="firstmenus"-->
<!--                index="/operation/operatorAudit/index"-->
<!--                style="padding-left:80px"-->
<!--                v-if="hasPermission(411)"-->
<!--              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">运营商审核</span></el-menu-item>-->
              <el-menu-item
                class="firstmenus"
                index="/operation/salesmanManagement/index"
                style="padding-left:80px"
                v-if="hasPermission(493)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">业务员管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/siteProfitSharing/index"
                style="padding-left:80px"
                v-if="hasPermission(528)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">分账配置</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/config/index"
                style="padding-left:80px"
                v-if="hasPermission(611)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">运营商个性配置</span></el-menu-item>
            </el-submenu>
            <el-submenu index="2-3" v-if="hasPermissionGroup(permissionGroup.operateManager.operatePrice)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="dingjia" style="font-size: 18px;"></svg-icon>
                 </div>
                 <span style="font-size: 14px;">定价管理</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/operation/LeaseTemplate/billingPage"
                style="padding-left:80px"
                v-if="hasPermission(12)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">租赁计费模板</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/ChangeBatTemplate/billingPage"
                style="padding-left:80px"
                v-if="hasPermission(428)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">换电计费模板</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/pricingManagement/SalesBillingTemplate/index"
                style="padding-left:80px"
                v-if="hasPermission(364)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">销售计费模板</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/pricingManagement/carBillingTemplate/index"
                style="padding-left:80px"
                v-if="hasPermission(473)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">车辆计费模板</span></el-menu-item>
            </el-submenu>
            <el-submenu index="2-4" v-if="hasPermissionGroup(permissionGroup.operateManager.operateCustomer)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="kehuguanli" style="font-size: 17px;"></svg-icon>
                  </div>
                  <span style="font-size: 14px;">客户管理</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/Customer/memberCustomers/index"
                style="padding-left:80px"
                v-if="hasPermission(73)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">会员客户</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/Customer/pupuMember/index"
                style="padding-left:80px"
                v-if="hasPermission(617)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">朴朴会员</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/Customer/idleMember/index"
                style="padding-left:80px"
                v-if="hasPermission(306)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">闲置会员客户</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/Customer/disabledApply/index"
                style="padding-left:80px"
                v-if="hasPermission(236)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">会员禁用审核</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/ClientManagement/clientPage"
                style="padding-left:80px"
                v-if="hasPermission(74)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">注册客户</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/realNameCheck/index"
                style="padding-left:80px"
                v-if="hasPermission(249)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">实名认证记录</span></el-menu-item>
            </el-submenu>
            <el-submenu index="2-5" v-if="hasPermissionGroup(permissionGroup.operateManager.operateFinance)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                    <div class="icon-wrap">
                        <svg-icon icon-class="caiwuguanli" style="font-size: 17px;"></svg-icon>
                    </div>
                    <span style="font-size: 14px;">财务管理</span>
                </div>
              </template>
              <el-menu-item
                index="/Finance/Recharge"
                style="padding-left:80px"
                v-if="hasPermission(19)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">资金流水</span></el-menu-item>
              <!-- <el-menu-item
                index="/Finance/revenueManagement"
                style="padding-left:80px"
                v-if="hasPermission(276)"
                class="firstmenus"
              >订单收入记录</el-menu-item> -->
              <el-menu-item
                index="/Finance/leaseOrdersRevenue"
                style="padding-left:80px"
                v-if="hasPermission(398)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">租赁订单收入记录</span></el-menu-item>
              <el-menu-item
                index="/Finance/revenueManagement2"
                style="padding-left:80px"
                v-if="hasPermission(424)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">换电订单收入记录</span></el-menu-item>
              <el-menu-item
                index="/Finance/carsOrderRevenue"
                style="padding-left:80px"
                v-if="hasPermission(488)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">车辆订单收入记录</span></el-menu-item>
              <el-menu-item
                index="/Finance/withdrawal"
                style="padding-left:80px;"
                v-if="hasPermission(101)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">提现审核</span></el-menu-item>
              <el-menu-item
                index="/Finance/thawApply"
                style="padding-left:80px;"
                v-if="hasPermission(502)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">押金解冻审核</span></el-menu-item>
              <el-menu-item
                index="/Finance/abnormalRentRefund"
                style="padding-left:80px;"
                v-if="hasPermission(377)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">异常退租审核</span></el-menu-item>
              <el-menu-item
                index="/Finance/memberBill/index"
                style="padding-left:80px"
                v-if="hasPermission(255)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">会员账单</span></el-menu-item>
              <el-menu-item
                index="/Finance/rechargeRecord/index"
                style="padding-left:80px"
                v-if="hasPermission(534)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">后台充值记录</span></el-menu-item>
            </el-submenu>
            <el-submenu index="2-6" v-if="hasPermissionGroup(permissionGroup.operateManager.marketingActivities)" class="secondary-menu">
              <!--   style="display:none"-->
              <template slot="title">
                <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="huodong" style="font-size: 19px;"></svg-icon>
                 </div>
                 <span style="font-size: 14px;">营销活动</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/marketingActivities/coupon/index"
                style="padding-left:80px"
                v-if="hasPermission(336)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">优惠券</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/marketingActivities/couponRecord/index"
                style="padding-left:80px"
                v-if="hasPermission(512)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">优惠券发放记录</span></el-menu-item>
               <el-menu-item
                class="firstmenus"
                index="/marketingActivities/frozenCoupon/index"
                style="padding-left:80px"
                v-if="hasPermission(561)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">冻结券</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/marketingActivities/userLabel/index"
                style="padding-left:80px"
                v-if="hasPermission(567)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">用户标签</span></el-menu-item>
            </el-submenu>
<!--            <el-submenu index="2-7" v-if="hasPermissionGroup(permissionGroup.operateManager.remoteUpgrade)" class="secondary-menu">-->
<!--              &lt;!&ndash;   style="display:none"&ndash;&gt;-->
<!--              <template slot="title">-->
<!--                <div class="title">-->
<!--                 <div class="icon-wrap">-->
<!--                   <svg-icon icon-class="yuancheng" style="font-size: 19px;"></svg-icon>-->
<!--                 </div>-->
<!--                 <span style="font-size: 14px;">远程升级</span>-->
<!--                </div>-->
<!--              </template>-->
<!--              <el-menu-item-->
<!--                class="firstmenus"-->
<!--                index="/operation/remoteUpgrade/communicationModule/index"-->
<!--                style="padding-left:80px"-->
<!--                v-if="hasPermission(342)"-->
<!--              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">通讯模块</span></el-menu-item>-->
<!--              <el-menu-item-->
<!--                class="firstmenus"-->
<!--                index="/operation/remoteUpgrade/bmsUpgrade/index"-->
<!--                style="padding-left:80px"-->
<!--                v-if="hasPermission(356)"-->
<!--              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">BMS</span></el-menu-item>-->
<!--               <el-menu-item-->
<!--                class="firstmenus"-->
<!--                index="/operation/remoteUpgrade/batterCommandBatch/index"-->
<!--                style="padding-left:80px"-->
<!--                v-if="hasPermission(584)"-->
<!--              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">电池命令批量执行</span></el-menu-item>-->
<!--            </el-submenu>-->
            <el-submenu index="2-8" v-if="hasPermissionGroup(permissionGroup.operateManager.apiInterface)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="api" style="font-size: 19px;"></svg-icon>
                 </div>
                 <span style="font-size: 14px;">API接口服务</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/operation/apiInterface/accountAuthority/index"
                style="padding-left:80px"
                v-if="hasPermission(448)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">账号权限管理</span></el-menu-item>
            </el-submenu>
            <el-menu-item index="/dashboard/operationReport" v-if="hasPermissionGroup(permissionGroup.operateManager.operateReport)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="yunyingbaobiao" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 14px;">换电运营报表</span>
              </div>
            </el-menu-item>

            <el-menu-item index="/operation/serviceChargeBill" v-if="hasPermissionGroup(permissionGroup.operateManager.serviceChargebill)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="zichanbaobiao" style="font-size: 24px;"></svg-icon>
                </div>
                <span style="font-size: 14px;">服务费账单</span>
              </div>
            </el-menu-item>
             <el-menu-item index="/operation/onlineBulletin" v-if="hasPermissionGroup(permissionGroup.operateManager.omlineBulletion)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="gonggao" style="font-size: 16px;"></svg-icon>
                </div>
                <span style="font-size: 14px;">线上公告</span>
              </div>
            </el-menu-item>



           </el-submenu>
           <!-- <div class="bgcolor" v-if="hasPermissionGroup([...permissionGroup.operateManager.operateOverview,...permissionGroup.operateManager.operateOrder,...permissionGroup.operateManager.operateBusiness,...permissionGroup.operateManager.operatePrice,...permissionGroup.operateManager.operateCustomer,...permissionGroup.operateManager.operateFinance,...permissionGroup.operateManager.operateReport])"></div> -->
          <el-submenu index="3"  v-if="hasPermissionGroup([...permissionGroup.aftersaleManager.onlineMonitoring,...permissionGroup.aftersaleManager.offlineAftersale,...permissionGroup.aftersaleManager.personManager,...permissionGroup.aftersaleManager.aftersaleReport])">
               <template slot="title">
              <div class="title navThemm">
                <div class="icon-wrap">
                  <svg-icon icon-class="shouhou" style="font-size: 28px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">售后服务</span>
              </div>
            </template>
            <el-submenu index="3-1" v-if="hasPermissionGroup(permissionGroup.aftersaleManager.onlineMonitoring)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="xianshang" style="font-size: 22px;"></svg-icon>
                  </div>
                  <span style="font-size: 14px;">线上监控</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/monitoring/unusual"
                style="padding-left:80px"
                v-if="hasPermission(16)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">电池异常告警(V1.0)</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/monitoring/towerAlarm"
                style="padding-left:80px"
                v-if="hasPermission(172)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">电池异常告警(V2.0)</span></el-menu-item>
               <el-menu-item
                class="firstmenus"
                index="/monitoring/batteryAbnormalAlarm"
                style="padding-left:80px"
                v-if="hasPermission(515)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">电池异常告警(V3.0)</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/monitoring/cabinetAlarm"
                style="padding-left:80px"
                v-if="hasPermission(440)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">换电柜异常告警</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/monitoring/alarmRemind"
                style="padding-left:80px"
                v-if="hasPermission(224)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">告警提醒设置</span></el-menu-item>
<!--              <el-menu-item-->
<!--                index="/monitoring/electronicFence"-->
<!--                style="padding-left:80px"-->
<!--                class="firstmenus"-->
<!--                v-if="hasPermission(17)"-->
<!--              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">电子围栏</span></el-menu-item>-->
            </el-submenu>
            <el-submenu index="3-2" v-if="hasPermissionGroup(permissionGroup.aftersaleManager.offlineAftersale)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="xianxia" style="font-size: 18px;"></svg-icon>
                  </div>
                  <span style="font-size: 14px;">线下售后</span>
                </div>
              </template>
              <el-menu-item
                index="/afterSale/afterSaleJobs"
                style="padding-left:80px"
                v-if="hasPermission(205)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">换电工单</span></el-menu-item>
              <el-menu-item
                index="/afterSale/faultContent"
                style="padding-left:80px"
                v-if="hasPermission(207)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">换电故障定义</span></el-menu-item>
              <el-menu-item
                index="/operation/disableLogging/index"
                style="padding-left:80px"
                class="firstmenus"
                v-if="hasPermission(299)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">仓门禁用记录</span></el-menu-item>
              <el-menu-item
                index="/afterSale/faultRecord"
                style="padding-left:80px"
                v-if="hasPermission(321)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">租赁工单</span></el-menu-item>
              <el-menu-item
                index="/afterSale/bmstTreshold"
                style="padding-left:80px"
                v-if="hasPermission(453)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">BMS保护阈值</span></el-menu-item>
              <el-menu-item
                index="/afterSale/hNdisabilitiesRecord"
                style="padding-left:80px"
                v-if="hasPermission(549)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">华诺报障记录</span></el-menu-item>
              <el-menu-item
                index="/afterSale/workOrder"
                style="padding-left:80px"
                v-if="hasPermission(576)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">BMS工单</span></el-menu-item>
            </el-submenu>
            <el-submenu index="3-3" v-if="hasPermissionGroup(permissionGroup.aftersaleManager.personManager)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="renyuan" style="font-size: 18px;"></svg-icon>
                  </div>
                  <span style="font-size: 14px;">人员管理</span>
                </div>
              </template>
              <el-menu-item
                index="/afterSale/afterSalePeople"
                style="padding-left:80px;"
                v-if="hasPermission(206)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">售后人员</span></el-menu-item>
<!--              <el-menu-item-->
<!--                index="/afterSale/clockRecord"-->
<!--                style="padding-left:80px;"-->
<!--                v-if="hasPermission(208)"-->
<!--                class="firstmenus"-->
<!--              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">售后打卡记录</span></el-menu-item>-->
              <el-menu-item
                index="/afterSale/afterSaleRole"
                style="padding-left:80px;"
                v-if="hasPermission(554)"
                class="firstmenus"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">售后人员角色</span></el-menu-item>
            </el-submenu>
            <el-submenu index="3-4" v-if="hasPermissionGroup(permissionGroup.aftersaleManager.aftersaleReport)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="shouhoubaobiao" style="font-size: 18px;"></svg-icon>
                  </div>
                  <span style="font-size: 14px;">售后报表</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/dashboard/monitoring"
                style="padding-left:80px;display:none"
                v-if="hasPermission(24)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">故障统计报表</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/dashboard/monitoring"
                style="padding-left:80px;display:none"
                v-if="hasPermission(24)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">工单统计报表</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/afterTheReport/report"
                style="padding-left:80px"
                v-if="hasPermission(24)"
              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">监控统计报表</span></el-menu-item>
            </el-submenu>
           </el-submenu>
           <!-- <div class="bgcolor" v-if="hasPermissionGroup([...permissionGroup.aftersaleManager.onlineMonitoring,...permissionGroup.aftersaleManager.offlineAftersale,...permissionGroup.aftersaleManager.personManager,...permissionGroup.aftersaleManager.aftersaleReport])"></div> -->

          <!-- <div class="bgcolor" v-if="hasPermissionGroup([...permissionGroup.productionManagement.personnelManagement,...permissionGroup.productionManagement.taskManagement])"></div> -->
           <el-submenu index="4" v-if="hasPermissionGroup([...permissionGroup.systemSettings.accountManager,...permissionGroup.systemSettings.roleManager,...permissionGroup.systemSettings.DataDictionary,...permissionGroup.systemSettings.accountLevel])">
            <template slot="title">
              <div class="title navThemm">
                <div class="icon-wrap">
                  <svg-icon icon-class="xitong" style="font-size: 25px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">系统设置</span>
              </div>
            </template>
            <el-menu-item-group>
              <el-menu-item
                class="secondary-menu"
                index="/systemSet/accountAdmin"
                style="padding-left:80px"
                v-if="hasPermission(26)"
              >账号管理</el-menu-item>
              <el-menu-item
                class="secondary-menu"
                index="/systemSet/roleAdmin/index"
                style="padding-left:80px"
                v-if="hasPermission(27)"
              >角色管理</el-menu-item>
              <!-- <el-menu-item
                @click="handleClick"
                class="firstmenus"
                index="/systemSet/DataDictionary"
                style="padding-left:80px"
                v-if="hasPermission(28)"
              >数据字典</el-menu-item> -->
              <el-menu-item
                @click="handleClick"
                class="secondary-menu secondary-menu-else"
                index="/systemSet/accountLevel/index"
                style="padding-left:80px"
                v-if="hasPermission(353)"
              >账号等级</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- <div class="bgcolor" v-if="hasPermissionGroup([...permissionGroup.systemSettings.accountManager,...permissionGroup.systemSettings.roleManager,...permissionGroup.systemSettings.DataDictionary,...permissionGroup.systemSettings.accountLevel])"></div> -->
        </el-menu>
      </el-aside>
      <div class="hidden-aside" v-else ></div>
      <div class='open_icon' @click="handleCollapse">
        <svg-icon icon-class="close_icon" style="font-size: 25px;" v-if="isCollapse"></svg-icon>
        <svg-icon icon-class="open_icon" style="font-size: 25px;" v-else></svg-icon>
      </div>
    </el-container>

    <!-- </el-menu> -->
  </div>
</template>
<style lang="scss">
.el-submenu__title{
   position: relative;
   margin-bottom: 10px;
}
.el-submenu__title:hover{
  background: transparent;
}
</style>

<style lang="scss" scoped>
.hidden-aside{
  width: 14px;
  height: calc(100vh - 60px);
  position: relative;
  background: rgba(0, 31, 56, 1);
  [data-theme="theme1"] & {
    background: #00182C;
  }
  [data-theme="theme2_skyblue"] & {
    background: #fff;
  }
}
.show-aside{
  transition: 0.5s;
  width: 244px!important;
  // display: none;
  background: rgba(0, 31, 56, 1);
// z-index: 11;
  [data-theme="theme1"] & {
    background: #00182C;
    box-shadow: 5px 0px 5px rgba(0, 217, 213, 0.35);
  }

  [data-theme="theme2_skyblue"] & {
    background: #fff;
    box-shadow: 6px 0px 12px rgba(18, 106, 233, 0.5);
  }
}
  .open_icon{
    // width: 25px;
    width: 20px;
    height: 129px;
    background: #001F38;
    cursor: pointer;
    [data-theme="theme2_skyblue"] & {
      background: #fff;
    }
    [data-theme="theme1"] & {
      background: #00182C;
    }
    border-radius: 0px 20px 20px 0px;
    z-index: 10;
    position:absolute;
    right:-11px;
    top: 50%;
    margin-top: -65px;
    display: flex;
    align-items: center;
    justify-content: center;
    .svg-icon{
      color: #ffffff;
      // z-index: 100;
      [data-theme="theme2_skyblue"] & {
        color: #03BAFF;
      }
    }

  }
.title {
  display: flex;
  align-items: center;
  .icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    line-height: 30px;
    padding-right: 10px;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import {loginErp} from "@/services/alarmRemind";
export default {
  inject: ["reload"], // 注入重载的功能（注入依赖）
  computed: {
    ...mapGetters(["theme"]),
  },

  data() {
    return {
      isCollapse: true,
      editableTabs2: [
        {
          title: "电池管理",
          name: "1",
          closable: false,
        },
      ],
    };
  },

  methods: {
      async handleToSupplyChain(){
           const res=await  loginErp(8);
           if(res){
               let url="http://erp.fnjkj.cn/#/login/tokenLogin?data="
               window.open(url+res.data)
           }
      },
      // 侧边栏展开收起
    handleCollapse(){
      this.isCollapse = !this.isCollapse;
    },
    //权限控制
    hasPermission(id) {
      // console.log(id,"id")
      return this.$store.getters.hasPermission(id);
    },
    // showBG(){
    //     return this.theme=="" || this.theme=="theme1"
    // },

    refs(name) {
      var that = this;
      that.$emit("listnone", name);
    },
    handleselect: function (a, b, index) {
      this.reload(); // 点击侧边栏重新载入页面
      // console.log(a)
      // console.log(index.itemStyle)
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClick() {},
  },
  //重写点击菜单的跳转方法
  // async mounted() {
  //     this.$refs.menus.routeToItem=(item)=>{
  //         let route = item.route || item.index;
  //         try {
  //             this.toCachePage({path:route});
  //         } catch (e) {
  //             console.error(e);
  //         }
  //      //   this.toCachePage({path:item})
  //     }
  // },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue